import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

const eInvoiceTypeOptions = [
  { value: 'draft', label: 'Staged Documents Report' },
  { value: 'active', label: 'eDocuments Report' },
  { value: 'aiExtraction', label: 'AI Extraction Report' },
];

const EInvoiceTypeSelect = ({ name, label = 'Report Type', control, errors, readOnly = false }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          id={name}
          options={eInvoiceTypeOptions}
          readOnly={readOnly}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              error={!!errors[name]}
              helperText={errors[name]?.message}
              size="small"
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          onChange={(_, value) => field.onChange(value)}
          value={field.value || null} // handle default value
          getOptionLabel={(option) => option.label || ''}
        />
      )}
    />
  );
};

export default EInvoiceTypeSelect;
